import TaskUpdateModal from "@/layouts/rightSideBar/BugHurd/components/TaskUpdateModal";
import {
  Avatar,
  AvatarGroup,
  Box,
  Card,
  CardContent,
  Typography,
  useTheme,
} from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { colorPalette, severityColorMap, typeToIconMapping } from "../utils";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { formatDate } from "./Task";
import TaskUpdateDrawer from "@/pages/Board/bugherdComponents/TaskUpdateDrawer";
export const Subtask = ({
  subtask,
  parentTask,
  index,
  users,
  refreshColumn,
  availableStatus,
}: {
  subtask: any;
  parentTask: any;
  index: number;
  users: any[];
  refreshColumn?: () => void;
  availableStatus?: any[];
}) => {
  const theme = useTheme();
  const { t } = useTranslation(["bugherd"]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [closeModel, setCloseModel] = useState(false);

  // const statusObj = availableStatus?.find(
  //   (status) => status._id === subtask.bugStatus
  // );
  const statusLabel = subtask?.bugStatus?.status;
  const handleClick = () => {
    setIsModalOpen(true);
  };

  const handleClose = () => {
    setIsModalOpen(false);
  };

  const getInitials = (name) => {
    return name
      .split(" ")
      .map((part) => part[0])
      .join("")
      .toUpperCase()
      .slice(0, 2);
  };
  const typeInfo = subtask?.type
    ? typeToIconMapping[subtask.type]
    : typeToIconMapping.TASK;
  return (
    <>
      <Card
        onClick={handleClick}
        sx={{
          mb: 1,
          borderRadius: "6px",
          boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
          cursor: "pointer",
          border: `1px solid ${theme.palette.text.primary}`,
          backgroundColor: theme.palette.background.paper,
          "&:hover": {
            backgroundColor: theme.palette.background.paper,
          },
          ml: 2,
        }}
      >
        <CardContent sx={{ padding: "8px 12px", "&:last-child": { pb: 1 } }}>
          <Box sx={{ display: "flex", alignItems: "flex-start" }}>
            {subtask?.type && (
              <Box
                sx={{
                  width: 14,
                  height: 14,
                  borderRadius: "3px",
                  backgroundColor: typeInfo.bgcolor,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mr: 1,
                  mt: 0.3,
                  flexShrink: 0,
                }}
              >
                {typeInfo.icon}
              </Box>
            )}

            <Box sx={{ flex: 1 }}>
              <Typography
                variant="subtitle2"
                sx={{
                  fontSize: "13px",
                  fontWeight: 500,
                  color: "text.primary",
                  display: "flex",
                  alignItems: "center",
                  mb: 0.5,
                }}
              >
                {subtask?.bugKey && (
                  <span style={{ marginRight: "4px", color: "#757575" }}>
                    {subtask.bugKey}:
                  </span>
                )}
                {subtask?.summary}
              </Typography>

              {/* Add status display */}
              <Box sx={{ display: "flex", alignItems: "center", mb: 0.5 }}>
                <FiberManualRecordIcon
                  sx={{
                    fontSize: 8,
                    // color: statusColor,
                    mr: 0.5,
                  }}
                />
                <Typography
                  sx={{
                    fontSize: "10px",
                    // color: statusColor,
                    fontWeight: 500,
                    textTransform: "capitalize",
                  }}
                >
                  {statusLabel}
                </Typography>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  mt: 0.5,
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  {subtask?.assignTo?.length > 0 ? (
                    <AvatarGroup
                      max={2}
                      sx={{
                        "& .MuiAvatar-root": {
                          width: 20,
                          height: 20,
                          fontSize: "10px",
                          border: "2px solid #f9f9f9",
                        },
                      }}
                    >
                      {subtask.assignTo.map((item, idx) => (
                        <Avatar
                          key={idx}
                          sx={{
                            backgroundColor:
                              colorPalette[idx % colorPalette.length],
                          }}
                        >
                          {getInitials(item.fullName)}
                        </Avatar>
                      ))}
                    </AvatarGroup>
                  ) : (
                    <Typography
                      variant="caption"
                      sx={{ color: "text.secondary", fontSize: "11px" }}
                    >
                      {t("Unassigned")}
                    </Typography>
                  )}

                  {subtask?.severity && (
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        ml: 1,
                      }}
                    >
                      <FiberManualRecordIcon
                        sx={{
                          fontSize: 8,
                          color:
                            severityColorMap[subtask.severity] || "#9E9E9E",
                          mr: 0.5,
                        }}
                      />
                      <Typography
                        sx={{
                          fontSize: "10px",
                          color: "text.secondary",
                        }}
                      >
                        {subtask.severity}
                      </Typography>
                    </Box>
                  )}
                </Box>

                {subtask?.dueDate && (
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <CalendarMonthOutlinedIcon
                      sx={{ fontSize: 12, mr: 0.5, color: "text.secondary" }}
                    />
                    <Typography
                      sx={{
                        fontSize: "10px",
                        color: "text.secondary",
                      }}
                    >
                      {formatDate(subtask.dueDate)}
                    </Typography>
                  </Box>
                )}
              </Box>
            </Box>
          </Box>
        </CardContent>
      </Card>
      {/* {isModalOpen && (
        <TaskUpdateModal
          open={isModalOpen}
          onClose={handleClose}
          setBugId={() => {}}
          setDrawerOpen={() => {}}
          bugId={subtask?._id}
          users={users}
          createdBy={subtask?.createdBy?.fullName || ""}
          setCreatedBy={() => {}}
          refreshColumn={refreshColumn}
        />
      )} */}
      {isModalOpen && (
        <TaskUpdateDrawer
          open={isModalOpen}
          onClose={handleClose}
          setBugId={() => {}}
          setDrawerOpen={() => {}}
          bugId={subtask?._id}
          users={users}
          createdBy={subtask?.createdBy?.fullName || ""}
          setCreatedBy={() => {}}
          refreshColumn={refreshColumn}
        />
      )}
    </>
  );
};
